
import React from 'react'
import './index.less'
console.log(React)
export default function TopImage(props) {
  return (<div className={`topImage`} style={{
    width: 375,
    opacity: 0.5
  }}>
    {props.ifon.ifon.imageList.length

      ? <div className='topImage_ifon'>
        {props.ifon.ifon.imageList.map((itme, index) => {
          return (
            <div className={`ifon_img ${props.ifon.ifon.currentIndex === index ? 'active' : ''}`} key={itme.id} style={{
              width: itme.fileIfon.width,
              minHeight: itme.fileIfon.height,
              paddingTop: itme.fileIfon.paddingTop,
              paddingBottom: itme.fileIfon.paddingBottom,
              paddingLeft: itme.fileIfon.paddingLeft,
              paddingRight: itme.fileIfon.paddingRight

            }}>
              <img draggable='false' className='img' style={{ height: itme.fileIfon.height }} src={itme.fileIfon.src} />
              {itme.isHotZone && itme.hotZoneQuantity.map((item1, index1) => {
                return (<span key={item1.id} style={{
                  width: itme.hotZone[index1].width,
                  height: itme.hotZone[index1].height,
                  top: itme.hotZone[index1].y,
                  left: itme.hotZone[index1].x
                }} className='hotspot'></span>)
              })}
            </div>
          )
        })}
      </div>

      : <div className='topImage_seizeASeat'>
        <img className='seizeASeat_image' src='https://read.e.qq.com/assets/images/yuebao/icon_upload_back.png' />
      </div>}
  </div>)
}

